<template>
    <div class="col-12 table-footer table-footer-left">
          <div class="row align-items-center no-margin">
            <div class="col">
              <div class="titlesec">Total Indents : {{totalIntends}}</div>
            </div>
            <div class="col-3">
              <ul class="table-footer-list">
                <li>
                  <div class="titlesec"> {{(isClientAccepted) ? 'Payable' : 'Requested' }}</div>
                </li>
                <li class="fltright">
                  <div class="titleprimary">{{ (isClientAccepted) ? calculateTotal.client.toFixed(2) :calculateTotal.transporter.toFixed(2) }}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
</template>
<script>
export default {
  props: ['totalIntends', 'getTotal'],
  computed: {
    calculateTotal() {
      const total = { transporter: 0, client: 0 };
      this.getTotal.forEach((val, index) => {
        const selected = val.total_amount;
        if (selected) {
          total.transporter += Number(selected.transporter);
          total.client += Number(selected.client);
        }
      });
      return total;
    },
    isClientAccepted() {
      if (!this.$hasFeature('edit_invoice_post_invoice')) {
        let approved = false;
        if (this.$store.invoice && this.$store.invoice.status) {
          approved = this.$store.invoice.status >= 3;
        }
        return approved;
      }
      return false;
    },
  },
};
</script>
